/**
 * EmptyState Component (T076)
 *
 * Reusable empty state component for displaying "no items" messages
 * with optional action button.
 */

import { cn } from '@/lib/utils';
import { Button } from './button';
import { LucideIcon } from 'lucide-react';

interface IEmptyStateProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function EmptyState({
  title,
  description,
  icon: Icon,
  actionLabel,
  onAction,
  className,
}: IEmptyStateProps) {
  return (
    <div
      className={cn(
        'border-2 border-dashed rounded-lg p-12 text-center',
        className
      )}
      role="status"
      aria-label={title}
    >
      <div className="max-w-md mx-auto space-y-4">
        {Icon && (
          <div className="flex justify-center">
            <Icon
              className="h-12 w-12 text-muted-foreground"
              aria-hidden="true"
            />
          </div>
        )}
        <h3 className="text-xl font-semibold">{title}</h3>
        {description && (
          <p className="text-muted-foreground">{description}</p>
        )}
        {actionLabel && onAction && (
          <Button onClick={onAction} size="lg">
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
